<app-modal class="app-cache-inspector-popup">
	<div modal-body class="app-cache-inspector-popup__body">
		<dcds-cache-inspector></dcds-cache-inspector>
	</div>
</app-modal>
